// extracted by mini-css-extract-plugin
module.exports = {"glaStrip":"GLAStrip_glaStrip__3QwD6","button":"GLAStrip_button__3l5iw"};